
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import functionCall from './function-call.js';
import aCallable$1 from './a-callable.js';
import anObject$1 from './an-object.js';
import tryToString$1 from './try-to-string.js';
import getIteratorMethod$1 from './get-iterator-method.js';

var call = functionCall;
var aCallable = aCallable$1;
var anObject = anObject$1;
var tryToString = tryToString$1;
var getIteratorMethod = getIteratorMethod$1;

var $TypeError = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw new $TypeError(tryToString(argument) + ' is not iterable');
};

export { getIterator as default };
//# sourceMappingURL=get-iterator.js.map
